import React, { useEffect } from "react";
import { Image } from "@learningblocks/shared-components";
import "./style.scss";
import { SimManager } from "@learningblocks/simulation-engine";

export const Results = (props) => {
  useEffect(() => {
    //SimManager.getInstance().openModal("ThumbnailModal", "ThumbnailModal");
  }, [props.selectedThumbnail]);

  const openImageModal = () => {
    //props.selectThumbnail(magnification);
  };

  const ResultsImages = () => {
    const images = props.magnifications;

    return images.map((magnification) => (
      <div className="resultsImages">
        <div className="image">
          {
            <Image
              width="100%"
              src={
                magnification.image
                  ? magnification.image
                  : "images/sorter/Plate.svg"
              }
              alt={
                magnification.image
                  ? SimManager.getInstance().getState("Microscope") ===
                    "slide2Inserted"
                    ? magnification.value === "2.5x"
                      ? `Your specimen through the ${magnification.value} lens. If you took a focused, centered photo through the 2.5x lens, your specimen looks like this: it is pink and looks like a pleated sheet of tissue paper, with a brown blob on each fold.`
                      : magnification.value === "10x"
                        ? `Your specimen through the ${magnification.value} lens. If you took a focused, centered photo through the 210x lens, your specimen looks like this: we focus on 2 of the darker brown patches. At this level of magnification, smaller dark pink patches are also clear.`
                        : `Your specimen through the 40x lens. We focus even further on the mottled brown and dark pink patches.`
                    : magnification.value === "2.5x"
                      ? `Your specimen through the ${magnification.value} lens. If you took a focused, centered photo through the 2.5x lens, your specimen looks like this: it is shades of purple and is a bulbous shape along a cord-like shape. Inside the bulbous shape are what look like several bubbles clustered around a darker, more finely detailed center.`
                      : magnification.value === "10x"
                        ? `Your specimen through the ${magnification.value} lens. If you took a clearly-focused, clearly-centred photo through the 10x lens, your specimen looks like this: we focus on the finely-detailed center; it is made up of tiny packed segments, like in an orange.`
                        : `Your specimen through the ${magnification.value} lens. If you took a focused, centered photo through the 40x lens, your specimen looks like this: We focus on the bubble-like shapes inside the segments. At this level of magnification, it resembles a web or loosely-crocheted cloth; the bubble shapes, which vary in size and shape, are the holes between strands. `
                  : "Microscope stage plate"
              }
              onClick={() =>
                magnification.image && openImageModal(magnification)
              }
            />
          }
        </div>
      </div>
    ));
  };

  return <div className="resultsImagesWrapper">{ResultsImages()}</div>;
};
